import * as apiModul from '@/lib/api';

/* Übergang (15.10.2026): Der Umschalter `setErnaehrungClient(client, praefix)` / `clearErnaehrungClient()` entsteht im
   Routen-Paket in lib/api.js (Spiegel `/api/coach/x/...` mit Trainer-Token). Solange er dort fehlt, tun die beiden
   Funktionen nichts — die Ernährungskarten rufen dann wie bisher die CRM-Routen auf. Der Name wird zur Laufzeit
   zusammengesetzt, damit der Bundler keinen festen Export verlangt (sonst „not exported“ beim Bauen dieses Zweigs
   allein). Nach dem Zusammenführen bleibt hier nur der Re-Export:
     export { setErnaehrungClient, clearErnaehrungClient } from '@/lib/api'; */
const name = (teil) => `${teil}ErnaehrungClient`;
const nimm = (teil) => { const f = apiModul[name(teil)]; return typeof f === 'function' ? f : () => {}; };
export const setErnaehrungClient = (...a) => nimm('set')(...a);
export const clearErnaehrungClient = (...a) => nimm('clear')(...a);
export const ernaehrungClientVorhanden = () => typeof apiModul[name('set')] === 'function';
